import { render, staticRenderFns } from "./buy-now-sign-up-confirmation.vue?vue&type=template&id=554be215&scoped=true&"
import script from "./buy-now-sign-up-confirmation.vue?vue&type=script&lang=js&"
export * from "./buy-now-sign-up-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./buy-now-sign-up-confirmation.vue?vue&type=style&index=0&id=554be215&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554be215",
  null
  
)

export default component.exports